import React from 'react';
import { ArrowRight, GraduationCap, School, ShoppingCart, Briefcase, Zap } from 'lucide-react';

export default function Projects({ darkMode, language, navigateTo }) {
  const isRTL = language === 'ar';

  const content = {
    fr: {
      projects: [
        {
          id: 'supemir',
          icon: GraduationCap,
          title: 'SUPEMIR Platform',
          subtitle: 'Système de Gestion Scolaire',
          description: 'Plateforme complète de gestion scolaire avec 6 rôles utilisateurs et dashboard financier avancé.',
          features: [
            '6 Rôles utilisateurs distincts',
            'Dashboard Financier avancé',
            'Chat en temps réel',
            'Système d\'inscription intelligent'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800',
          color: '#4F46E5',
          page: 'project-supemir'
        },
        {
          id: 'kastler',
          icon: School,
          title: 'Alfred Kastler',
          subtitle: 'Système Éducatif Complet',
          description: 'Plateforme scolaire avec système QR badges, portail parents et intégration WhatsApp.',
          features: [
            'Système de Badges QR',
            'Portail Parents complet',
            'Intégration WhatsApp API',
            'Dashboard suivi temps réel'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800',
          color: '#10B981',
          page: 'project-kastler'
        },
        {
          id: 'ecommerce',
          icon: ShoppingCart,
          title: 'E-commerce Platform',
          subtitle: 'Boutique en Ligne Complète',
          description: 'Plateforme e-commerce avec checkout invité, tracking commandes et dashboard admin avancé.',
          features: [
            'Checkout Invité sans compte',
            'Tracking commandes intelligent',
            'Système Wishlist complet',
            'Dashboard Admin statistiques'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=800',
          color: '#F59E0B',
          page: 'project-ecommerce'
        },
        {
          id: 'abs',
          icon: Briefcase,
          title: 'ABS Compétences',
          subtitle: 'Site Web Entreprise',
          description: 'Site corporate avec système blog/news et panel admin complet pour gestion de contenu.',
          features: [
            'Design Responsive moderne',
            'Panel Admin gestion contenu',
            'Système Blog/News intégré',
            'SEO optimisé'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
          color: '#6366F1',
          page: 'project-abs'
        },
        {
          id: 'azure',
          icon: Zap,
          title: 'Azure Group',
          subtitle: 'Site Vitrine Produits',
          description: 'Site moderne pour Azure Group présentant leurs produits et services avec interface clean.',
          features: [
            'Catalogue Produits images',
            'Section Profil Entreprise',
            'Aperçu Services complet',
            'Interface Clean & Moderne'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
          color: '#06B6D4',
          page: 'project-azure'
        }
      ]
    },
    ar: {
      projects: [
        {
          id: 'supemir',
          icon: GraduationCap,
          title: 'منصة SUPEMIR',
          subtitle: 'نظام إدارة مدرسي',
          description: 'منصة كاملة لإدارة المدارس مع 6 أدوار مستخدمين ولوحة مالية متقدمة.',
          features: [
            '6 أدوار مستخدمين مختلفة',
            'لوحة مالية متقدمة',
            'محادثة فورية',
            'نظام تسجيل ذكي'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800',
          color: '#4F46E5',
          page: 'project-supemir'
        },
        {
          id: 'kastler',
          icon: School,
          title: 'Alfred Kastler',
          subtitle: 'نظام تعليمي متكامل',
          description: 'منصة مدرسية مع نظام بطاقات QR، بوابة الأولياء وتكامل واتساب.',
          features: [
            'نظام بطاقات QR',
            'بوابة الأولياء كاملة',
            'تكامل واتساب API',
            'لوحة متابعة فورية'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800',
          color: '#10B981',
          page: 'project-kastler'
        },
        {
          id: 'ecommerce',
          icon: ShoppingCart,
          title: 'منصة التجارة الإلكترونية',
          subtitle: 'متجر إلكتروني متكامل',
          description: 'منصة تجارة إلكترونية مع الدفع كضيف، تتبع الطلبات ولوحة إدارة متقدمة.',
          features: [
            'الدفع كضيف بدون حساب',
            'تتبع طلبات ذكي',
            'نظام قائمة أمنيات',
            'لوحة إدارة إحصائيات'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=800',
          color: '#F59E0B',
          page: 'project-ecommerce'
        },
        {
          id: 'abs',
          icon: Briefcase,
          title: 'ABS Compétences',
          subtitle: 'موقع الشركة',
          description: 'موقع شركة مع نظام مدونة/أخبار ولوحة إدارة كاملة لإدارة المحتوى.',
          features: [
            'تصميم متجاوب حديث',
            'لوحة إدارة المحتوى',
            'نظام مدونة/أخبار مدمج',
            'محسّن لمحركات البحث'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
          color: '#6366F1',
          page: 'project-abs'
        },
        {
          id: 'azure',
          icon: Zap,
          title: 'Azure Group',
          subtitle: 'موقع عرض المنتجات',
          description: 'موقع حديث لـ Azure Group يعرض منتجاتهم وخدماتهم بواجهة نظيفة.',
          features: [
            'كتالوج المنتجات بالصور',
            'قسم ملف الشركة',
            'عرض الخدمات الكامل',
            'واجهة نظيفة وحديثة'
          ],
          backgroundImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
          color: '#06B6D4',
          page: 'project-azure'
        }
      ]
    }
  };

  const t = content[language];

  const styles = {
    projectsSection: {
      width: '100%',
      minHeight: '100vh',
      background: darkMode ? '#1F2937' : '#f8f9fa',
      display: 'flex',
      alignItems: 'stretch',
      padding: 0
    },
    projectsRow: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    projectCard: {
      width: '20%',
      padding: '30px 15px',
      minHeight: '100vh',
      position: 'relative',
      backgroundColor: darkMode ? '#374151' : 'white',
      borderRight: `1px solid ${darkMode ? '#4B5563' : '#eee'}`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },
    projectCardLast: {
      borderRight: 'none'
    },
    cardContent: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      width: '100%'
    },
    projectIcon: {
      width: '55px',
      height: '55px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '15px',
      background: 'linear-gradient(to right, #3B82F6, #9333EA)',
      borderRadius: '50%',
      padding: '10px',
      transition: 'all 0.3s ease'
    },
    projectTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '5px',
      transition: 'all 0.3s ease',
      background: 'linear-gradient(to right, #3B82F6, #9333EA)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    },
    projectSubtitle: {
      fontSize: '13px',
      color: darkMode ? '#9CA3AF' : '#666',
      marginBottom: '10px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      textAlign: 'center'
    },
    divider: {
      width: '40px',
      height: '2px',
      backgroundColor: '#5AC8E0',
      marginBottom: '20px'
    },
    projectDescription: {
      fontSize: '13px',
      color: darkMode ? '#D1D5DB' : '#666',
      textAlign: 'center',
      marginBottom: '20px',
      lineHeight: '1.5',
      maxWidth: '200px',
      transition: 'all 0.3s ease'
    },
    featuresList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      textAlign: isRTL ? 'right' : 'left',
      fontSize: '13px',
      lineHeight: '1.8',
      maxWidth: '200px',
      fontWeight: '600',
      flexGrow: 1,
      color: darkMode ? '#D1D5DB' : '#333',
      transition: 'all 0.3s ease',
      marginBottom: '20px'
    },
    featureItem: {
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      flexDirection: isRTL ? 'row-reverse' : 'row'
    },
    featureBullet: {
      width: '6px',
      height: '6px',
      backgroundColor: '#5AC8E0',
      borderRadius: '50%',
      marginTop: '8px',
      flexShrink: 0
    },
    projectButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: 'linear-gradient(to right, #3B82F6, #9333EA)',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '50px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '13px',
      transition: 'all 0.3s ease',
      marginTop: 'auto',
      marginBottom: '10px',
      border: '2px solid transparent',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      cursor: 'pointer'
    }
  };

  const responsiveStyles = `
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    /* Desktop: 5 cards en ligne */
    @media (min-width: 769px) {
      .project-card {
        width: 20% !important;
        min-height: 100vh !important;
        padding: 30px 15px !important;
      }

      .project-icon {
        width: 55px !important;
        height: 55px !important;
      }

      .project-title {
        font-size: 18px !important;
      }

      .project-subtitle {
        font-size: 13px !important;
      }

      .project-description {
        font-size: 13px !important;
        max-width: 200px !important;
      }

      .features-list {
        font-size: 13px !important;
        max-width: 200px !important;
      }

      .project-button {
        padding: 12px 20px !important;
        font-size: 13px !important;
      }
    }

    /* Mobile uniquement: colonne verticale */
    @media (max-width: 768px) {
      .projects-section {
        padding: 20px 0 !important;
      }

      .projects-row {
        flex-direction: column !important;
      }

      .project-card {
        width: 100% !important;
        min-height: auto !important;
        padding: 30px 20px !important;
        border-right: none !important;
        border-bottom: 1px solid #eee;
      }

      .project-icon {
        width: 55px !important;
        height: 55px !important;
      }

      .project-title {
        font-size: 20px !important;
      }

      .project-subtitle {
        font-size: 14px !important;
      }

      .project-description {
        font-size: 14px !important;
        max-width: 100% !important;
      }

      .features-list {
        font-size: 14px !important;
        text-align: center !important;
        max-width: 100% !important;
      }

      .project-button {
        padding: 12px 22px !important;
        font-size: 14px !important;
      }
    }

    .project-card::before {
      content: "";
      position: absolute;
      inset: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 0;
    }

    .project-card::after {
      content: "";
      position: absolute;
      inset: 0;
      background-color: rgba(90, 200, 224, 0.6);
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 1;
    }

    .project-card:hover::before {
      opacity: 1;
    }

    .project-card:hover::after {
      opacity: 1;
    }

    .project-card:hover .project-icon {
      background-color: #5AC8E0;
      transform: scale(1.1);
    }

    .project-card:hover .project-title {
      transform: scale(1.1);
      font-weight: 800;
      color: white !important;
    }

    .project-card:hover .project-subtitle {
      color: white !important;
      font-weight: 700;
    }

    .project-card:hover .project-description {
      color: white !important;
      font-weight: 600;
    }

    .project-card:hover .features-list {
      transform: scale(1.05);
      font-weight: 600;
      color: white !important;
    }

    .project-card:hover .project-button {
      background: white !important;
      color: #5AC8E0 !important;
      border: 2px solid #5AC8E0 !important;
    }

    .project-card:hover .project-button:hover {
      background: #5AC8E0 !important;
      color: white !important;
      border: 2px solid #5AC8E0 !important;
    }

    .project-button svg {
      transition: transform 0.3s ease;
    }

    .project-button:hover svg {
      transform: translateX(3px);
    }

    .project-supemir::before {
      background-image: url('https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800');
    }

    .project-kastler::before {
      background-image: url('https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800');
    }
    
    .project-ecommerce::before {
      background-image: url('https://images.unsplash.com/photo-1557821552-17105176677c?w=800');
    }

    .project-abs::before {
      background-image: url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800');
    }

    .project-azure::before {
      background-image: url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800');
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .project-card {
      animation: fadeInUp 0.8s ease forwards;
      opacity: 0;
    }

    .project-card:nth-child(1) {
      animation-delay: 0.2s;
    }
    .project-card:nth-child(2) {
      animation-delay: 0.4s;
    }
    .project-card:nth-child(3) {
      animation-delay: 0.6s;
    }
    .project-card:nth-child(4) {
      animation-delay: 0.8s;
    }
    .project-card:nth-child(5) {
      animation-delay: 1s;
    }
  `;

  const handleCardClick = (project) => {
    navigateTo(project.page);
  };

  const handleDiscoverClick = (e, project) => {
    e.stopPropagation();
    navigateTo(project.page);
  };

  return (
    <section style={{ width: '100%', minHeight: '100vh', padding: 0, margin: 0 }}>
      <style dangerouslySetInnerHTML={{ __html: responsiveStyles }} />
      
      <div style={styles.projectsSection} className="projects-section">
        <div style={styles.projectsRow} className="projects-row">
          {t.projects.map((project, index) => {
            const IconComponent = project.icon;
            return (
              <div 
                key={project.id}
                style={{
                  ...styles.projectCard,
                  ...(index === t.projects.length - 1 ? styles.projectCardLast : {})
                }}
                className={`project-card project-${project.id}`}
                onClick={() => handleCardClick(project)}
              >
                <div style={styles.cardContent}>
                  <div style={styles.projectIcon} className="project-icon">
                    <IconComponent size={32} strokeWidth={2.5} color="white" />
                  </div>

                  <h5 style={styles.projectTitle} className={`project-title ${isRTL ? 'font-arabic' : ''}`}>
                    {project.title}
                  </h5>

                  <div style={styles.projectSubtitle} className={`project-subtitle ${isRTL ? 'font-arabic' : ''}`}>
                    {project.subtitle}
                  </div>

                  <div style={styles.divider}></div>

                  <p style={styles.projectDescription} className={`project-description ${isRTL ? 'font-arabic' : ''}`}>
                    {project.description}
                  </p>

                  <ul style={styles.featuresList} className={`features-list ${isRTL ? 'font-arabic' : ''}`}>
                    {project.features.map((feature, idx) => (
                      <li key={idx} style={styles.featureItem}>
                        <div style={styles.featureBullet}></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <div 
                    style={styles.projectButton}
                    className="project-button"
                    onClick={(e) => handleDiscoverClick(e, project)}
                  >
                    <span>{language === 'fr' ? 'Découvrir' : 'اكتشف'}</span>
                    <ArrowRight size={16} strokeWidth={3} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}